export const countryEmergNum = [
  {
    country: "USA",
    emergency: "911",
    suicidePrevention: [
      "National Suicide Prevention Lifeline",
      "+1 (800) 273-8255",
    ],
    number: ["Family Violence Helpline", "+1 (800) 996-6228"],
    website: [
      "Suicide Prevention Wiki",
      "suicideprevention.wikia.com",
      "https://findahelpline.com/us/topics/suicidal-thoughts",
    ],
  },
  {
    country: "UK",
    emergency: "999 / 112",
    suicidePrevention: ["Hotline (UK - Local rate)", "+44 (0) 8457 90 90 90"],
    website: [
      "Help for suicidal thoughts (UK)",
      "nhs.uk",
      "https://www.nhs.uk/mental-health/feelings-symptoms-behaviours/behaviours/help-for-suicidal-thoughts/",
    ],
    number: ["Hotline (UK - Minicom)", "+44 (0) 8457 90 91 92"],
  },
  {
    country: "CANADA",
    emergency: "911",
    suicidePrevention: ["Hotline", "+1 (888) 353-2273"],
    website: [
      "Suicide Prevention Wiki",
      "suicideprevention.wikia.com",
      "https://www.suicideprevention.wikia.com",
    ],
    number: ["YourLifeCounts.org", "yourlifecounts.org"],
  },
  {
    country: "EUROPE",
    emergency: "112",
    suicidePrevention: [
      "Suicide Prevention Wiki",
      "suicideprevention.wikia.com",
    ],
    website: [
      "YourLifeCounts.org",
      "yourlifecounts.org",
      "https://yourlifecounts.org/find-help/",
    ],
    number: ["", ""],
  },
  {
    country: "GHANA",
    emergency: "112",
    suicidePrevention: ["Hotline", "+233 244 471 279"],
    website: [
      "Suicide Prevention Wiki",
      "suicideprevention.wikia.com",
      "https://www.suicideprevention.wikia.com",
    ],
    number: ["Police Headquarters", "0302773900"],
  },
  {
    country: "NIGERIA",
    emergency: "112",
    suicidePrevention: [
      "Nigerian Suicide Prevention",
      "234 806 210 6493 / 234 809 210 6493 ",
    ],
    website: [
      "Suicide Prevention Wiki",
      "blog.opencounseling.com",
      "https://blog.opencounseling.com/hotlines-ng/",
    ],
    number: ["Lagos suicide hotlines", "080 5882 0777"],
  },
  {
    country: "CHINA",
    emergency: "110",
    suicidePrevention: ["First-aid Ambulance", "120"],
    website: [
      "lifelinechina.org",
      "https://lifelinechina.org/",
      "https://lifelinechina.org/",
    ],
    number: ["Lifeline Shanghai", "(21) 63798990"],
  },
  {
    country: "INDIA",
    emergency: "112",
    suicidePrevention: ["AASRA Helpline", "91-9820466726"],
    website: [
      " AASRA HELPLINE NUMBERS",
      "aasra.info",
      "http://www.aasra.info/helpline.html",
    ],
    number: ["HELPLINE", "18005990019"],
  },
];
